<template>
	<screen class="tos-view">
		<div class="center">
			<img src="@/assets/legal.svg" v-bind:style="{ height: '150px' }" />
			<h2>We've updated our Terms of Service and Privacy Policy.</h2>
			<p>
				We made it easier to read, and included langauge about how
				roundups and donations are processed.
			</p>
			<div class="welcome-actions">
				<ui-button @click="accept">Accept and Continue</ui-button>
				<p v-bind:style="{ fontSize: '8px' }">
					By continuing you agree to the new
					<a href="https://roundupapp.com/terms/" target="_blank"
						>Terms of Service</a
					>
					and
					<a href="https://roundupapp.com/privacy/" target="_blank"
						>Privacy Policy</a
					>.
				</p>
			</div>
		</div>
	</screen>
</template>

<script>
import { mapActions } from 'vuex'
import UiButton from '../../ui/Button'
import Screen from '../../ui/Screen'

export default {
	name: 'tos-view',
	components: { UiButton, Screen },
	methods: {
		...mapActions(['acceptTOS']),
		accept() {
			this.acceptTOS()
				.then(() => this.$router.push({ name: 'home' }))
				.catch(({ message }) => this.$swal('Error', message))
		}
	}
}
</script>

<style lang="scss">
.screen {
	&.launch-view {
		background-image: linear-gradient($gradient1, $gradient2, $gradient3);
		.center {
			display: flex;
			flex-direction: column;
			align-content: center;
			justify-content: center;
			text-align: center;
		}
	}
}
</style>
